import { DynamicFormModel } from "@midland-industries/Types/DynamicFormModels";

export const determineFormFieldIndexes = (
    formName: string,
    key: string,
    dynamicFormData: { forms: DynamicFormModel[] },
) => {
    const defaultIndex = -1;
    const findFormIndex = dynamicFormData?.forms?.findIndex(f => f.name === formName);
    if (findFormIndex < 0) {
        return {
            formIndex: -1,
            fieldIndex: -1,
        };
    }

    const findFieldIndex = dynamicFormData?.forms[findFormIndex]?.fields?.findIndex(f => f.key === key);
    return {
        formIndex: findFormIndex,
        fieldIndex: findFieldIndex > -1 ? findFieldIndex : defaultIndex,
    };
};
